import { constant } from './constant'

import { createSelector } from '@/factory'

const getTableWrapper = () => createSelector<HTMLElement>({ selector: constant.selector.tableWrapper })

export const getComponents = () => ({
	tableWrapper: getTableWrapper(),
})
